// deprecated
export default {
  name: 'SnackbarNotificationMixin',
  data() {
    return {
      notification: false,
      notificationMessage: '',
      notificationUpper: false,
      notificationActionText: '',
      handleNotificationAction: () => {},
    }
  },
  methods: {
    showNotification({
      message, upper = false, actionText, handleAction,
    }) {
      this.notification = true
      this.notificationMessage = message
      this.notificationUpper = upper
      this.notificationActionText = actionText
      this.handleNotificationAction = handleAction
    },
    closeNotification() {
      this.notification = false
      this.notificationMessage = ''
      this.notificationUpper = false
      this.notificationActionText = ''
      this.handleNotificationAction = () => {}
    },
  },
}
